import React from "react";

import TopNav from "./components/TopNav/TopNav";
import MainNav from "./components/MainNav/MainNav";

import Hero from "./components/Hero/Hero";
import About from "./components/About/About";
import Services from "./components/Services/Services";
import Projects from "./components/Projects/Projects";
import WhyChoose from "./components/WhyChoose/WhyChoose";
import News from "./components/News/News";
import Clients from "./components/Clients/Clients";
import CTA from "./components/CTA/CTA";
import Footer from "./components/Footer/Footer";

import WhoWeAre from "./components/WhoWeAre/WhoWeAre";
import WhatWeDo from "./components/WhatWeDo/WhatWeDo";
import ManagementTeam from "./components/ManagementTeam/ManagementTeam";
import Subsidiaries from "./components/Subsidiaries/Subsidiaries";
import Vessels from "./components/Vessels/Vessels";
import Careers from "./components/Careers/Careers";
import Contact from "./components/Contact/Contact";
import CommunityPage from "./components/Community/CommunityPage";


function App() {
  const pathname = window.location.pathname.replace(/\/+$/, "") || "/";

  /* ==================================================
     WHO WE ARE PAGE
     ================================================== */

  if (pathname === "/who-we-are") {
    return (
      <div className="app">

        {/* TOP NAVIGATION */}
        <TopNav />

        {/* MAIN NAVIGATION */}
        <MainNav />

        {/* WHO WE ARE PAGE */}
        <WhoWeAre />

        {/* FOOTER */}
        <Footer />

      </div>
    );
  }

  if (pathname === "/what-we-do") {
    return (
      <div className="app">

        {/* TOP NAVIGATION */}
        <TopNav />

        {/* MAIN NAVIGATION */}
        <MainNav />

        {/* WHAT WE DO PAGE */}
        <WhatWeDo />

        {/* FOOTER */}
        <Footer />

      </div>
    );
  }

  if (pathname === "/management") {
    return (
      <div className="app">

        {/* TOP NAVIGATION */}
        <TopNav />

        {/* MAIN NAVIGATION */}
        <MainNav />

        {/* MANAGEMENT TEAM PAGE */}
        <ManagementTeam />

        {/* FOOTER */}
        <Footer />

      </div>
    );
  }

  if (pathname === "/subsidiaries") {
    return (
      <div className="app">

        {/* TOP NAVIGATION */}
        <TopNav />

        {/* MAIN NAVIGATION */}
        <MainNav />

        {/* SUBSIDIARIES & AFFILIATES PAGE */}
        <Subsidiaries />

        {/* FOOTER */}
        <Footer />

      </div>
    );
  }

  if (pathname === "/projects") {
    return (
      <div className="app">

        {/* TOP NAVIGATION */}
        <TopNav />

        {/* MAIN NAVIGATION */}
        <MainNav />

        {/* PROJECTS PAGE */}
        <Projects />

        {/* FOOTER */}
        <Footer />

      </div>
    );
  }

  if (pathname === "/services") {
    return (
      <div className="app">
        <TopNav />
        <MainNav />
        <Services standalone />
        <Footer />
      </div>
    );
  }

  if (pathname === "/vessels") {
    return (
      <div className="app">
        <TopNav />
        <MainNav />
        <Vessels />
        <Footer />
      </div>
    );
  }

  if (pathname === "/careers") {
    return (
      <div className="app">
        <TopNav />
        <MainNav />
        <Careers />
        <Footer />
      </div>
    );
  }

  if (pathname === "/contact") {
    return (
      <div className="app">
        <TopNav />
        <MainNav />
        <Contact />
        <Footer />
      </div>
    );
  }

  if (
    pathname === "/community/hse" ||
    pathname === "/community/awards"
  ) {
    return (
      <div className="app">
        <TopNav />
        <MainNav />
        <CommunityPage page="hse" />
        <Footer />
      </div>
    );
  }

  if (pathname === "/community/commendations") {
    return (
      <div className="app">
        <TopNav />
        <MainNav />
        <CommunityPage page="outreach" />
        <Footer />
      </div>
    );
  }


  /* ==================================================
     HOMEPAGE
     ================================================== */

  return (
    <div className="app">

      {/* TOP NAVIGATION */}
      <TopNav />

      {/* MAIN NAVIGATION */}
      <MainNav />

      {/* HERO SECTION */}
      <Hero />

      {/* ABOUT US */}
      <About />

      {/* SERVICES */}
      <Services />

      {/* PROJECTS */}
      <Projects featuredOnly />

      {/* WHY CHOOSE STRIDES */}
      <WhyChoose />

      {/* NEWS & INSIGHTS */}
      <News />

      {/* CLIENTS & PARTNERS */}
      <Clients />

      {/* CALL TO ACTION */}
      <CTA />

      {/* FOOTER */}
      <Footer />

    </div>
  );
}

export default App;